<template>
  <div class="corpo-pagina home">
    <div class="row">
      <QrCode />
    </div>
  </div>
</template>

<script>

import QrCode from '@/components/QrCode.vue'

export default {
  name: 'app',
  data () {
    return {
    }
  },

  components: {
    QrCode
  }
}
</script>
